import React from 'react'
import { LabelTooltip } from '@fs/zion-ui'

export default function TempleLabel({ temple }) {
  if (temple) {
    return <LabelTooltip label={temple.name} target={<span>{temple.code}</span>} />
  }
  return <br />
}
